import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CollectionService } from '../services/collection-service.js';
import { DesignService } from '../services/design-service.js';
import { gridImage } from '../utils/design-image.js';
import { useLocale } from '../hooks/useLocale.jsx';

// Mosaic preview = 1 large cover + up to 3 small thumbs (latest items).
// We only fetch the items list lazily on first mount.
export function CollectionCard({ collection: c }) {
  const { t } = useLocale();
  const navigate = useNavigate();
  const [thumbs, setThumbs] = useState([]); // array of generatedImageUrl strings

  useEffect(() => {
    let mounted = true;
    (async () => {
      const items = await CollectionService.listItems(c.id, { max: 4 });
      const designs = await Promise.all(
        items.map(it => DesignService.getDesign(it.designId).catch(() => null)),
      );
      if (!mounted) return;
      setThumbs(designs.filter(Boolean).map(d => gridImage(d)).filter(Boolean));
    })();
    return () => { mounted = false; };
  }, [c.id]);

  const cover = thumbs[0];
  const rest = thumbs.slice(1, 4);
  // Pad rest to always render 3 cells for layout consistency
  while (rest.length < 3) rest.push(null);

  return (
    <button
      type="button"
      className="collection-card"
      onClick={() => navigate(`/c/${c.id}`)}
    >
      <div className="collection-card-mosaic">
        <div className="collection-card-cover">
          {cover ? (
            <img src={cover} alt="" loading="lazy" />
          ) : (
            <div className="collection-card-empty">
              <i className="material-symbols-rounded">collections_bookmark</i>
            </div>
          )}
        </div>
        <div className="collection-card-side">
          {rest.map((src, i) => (
            <div key={i} className="collection-card-side-cell">
              {src ? <img src={src} alt="" loading="lazy" /> : <div className="collection-card-empty-cell" />}
            </div>
          ))}
        </div>
      </div>
      <div className="collection-card-meta">
        <p className="collection-card-name">{c.name}</p>
        <p className="collection-card-count">
          {t('collectionItemCount', { n: c.itemCount || 0 })}
          {c.isPublic && (
            <span className="collection-card-pub">
              <i className="material-symbols-rounded">public</i>
            </span>
          )}
        </p>
      </div>
    </button>
  );
}
